import { keepPreviousData, useQuery } from '@tanstack/react-query';

export type ProgramGoal = {
  programgoalid: string;
  programdesc: string;
};

const getProgramGoals = async (
  searchQuery?: string,
  page?: number,
  limit?: number,
): Promise<{ programGoals: ProgramGoal[]; totalPages: number }> => {
  const params = new URLSearchParams();
  if (searchQuery) params.set('q', searchQuery);
  if (limit !== undefined) params.set('limit', String(limit));
  if (page !== undefined) params.set('page', String(page));
  const response = await fetch(`/api/program-goals?${params}`);
  return response.json();
};

export const PROGRAM_GOALS_QUERY_KEY = 'program-goals';

export const useProgramGoals = ({
  searchQuery,
  page,
  limit = 5,
}: {
  searchQuery?: string;
  page?: number;
  limit?: number;
}) =>
  useQuery({
    queryKey: [PROGRAM_GOALS_QUERY_KEY, searchQuery, page, limit],
    queryFn: () => getProgramGoals(searchQuery, page, limit),
    placeholderData: keepPreviousData,
  });
